export default "__VITE_ASSET__DKx4rouX__"